import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Chip from "@material-ui/core/Chip";
import Button from "components/CustomButtons/Button.js";
import SnackBarWiiba from "components/Snackbar/SnackBarWiiba";
import useMessage from "../../hooks/useMessage";
import { makeStyles } from "@material-ui/core/styles";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LockOpenIcon from "@material-ui/icons/LockOpen";

const useStyles = makeStyles(() => ({
  header: {
    background: "linear-gradient(135deg, #2e7d32 0%, #43a047 100%)",
    padding: "20px 24px",
    color: "#fff",
    textAlign: "center",
  },
  headerIcon: { fontSize: 40, color: "#fff", marginBottom: 8 },
  headerTitle: { fontSize: 18, fontWeight: 700, margin: 0, color: "#fff" },
  headerSub: { fontSize: 12, color: "#c8e6c9", margin: "4px 0 0" },
  body: { padding: "24px 24px 16px" },
  infoRow: {
    display: "flex", alignItems: "center", gap: 10,
    padding: "12px 16px", backgroundColor: "#f8f9fa",
    borderRadius: 8, marginBottom: 12, border: "1px solid #e0e0e0",
  },
  infoIcon: { color: "#90a4ae", fontSize: 20 },
  infoLabel: { fontSize: 11, color: "#90a4ae", textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 },
  infoValue: { fontSize: 14, color: "#263238", fontWeight: 600 },
  montoSection: {
    backgroundColor: "#f8f9fa", borderRadius: 8, padding: "16px",
    marginTop: 8, border: "1px solid #e0e0e0",
  },
  sectionTitle: {
    fontSize: 11, fontWeight: 700, color: "#546e7a",
    textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 8,
  },
  hint: { fontSize: 12, color: "#90a4ae", marginTop: 8 },
}));

const ModalIniciaCaja = ({ modalIniciaCaja, setModalIniciaCaja, getInicioCaja, usuario, bandera }) => {
  const classes = useStyles();
  const { opensnack, typesnackbar, message, handleMuestraSnack, handleClosesSnack } = useMessage();
  const [montoInicial, setMontoInicial] = useState("0");
  const [enviando, setEnviando] = useState(false);

  const userId = usuario?.userId;
  const userName = usuario?.nombre || usuario?.user || "Cajero";
  const ahora = new Date().toLocaleString("es-MX", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit"
  });

  const handleClose = () => {
    setModalIniciaCaja(false);
    setMontoInicial("0");
  };

  const handleConfirmar = () => {
    const monto = parseFloat(montoInicial) || 0;
    if (monto < 0) {
      handleMuestraSnack("El monto no puede ser negativo", "warning");
      return;
    }
    setEnviando(true);

    if (bandera === 1) {
      getInicioCaja(userId, monto, 1);
    } else {
      getInicioCaja({ numeroCajero: userId, MontoInicial: monto });
    }

    setEnviando(false);
    handleClose();
  };

  return (
    <>
      <SnackBarWiiba opensnack={opensnack} tipoSnackBar={typesnackbar}
        mensaje={message} handleClosesSnack={handleClosesSnack} />

      <Dialog open={modalIniciaCaja} onClose={handleClose} maxWidth="xs" fullWidth>
        {/* Header */}
        <div className={classes.header}>
          <LockOpenIcon className={classes.headerIcon} />
          <p className={classes.headerTitle}>Apertura de Caja</p>
          <p className={classes.headerSub}>Registre el inicio de operaciones del día</p>
        </div>

        <DialogContent className={classes.body}>
          {/* Info cajero */}
          <div className={classes.infoRow}>
            <PersonOutlineIcon className={classes.infoIcon} />
            <div style={{ flex: 1 }}>
              <Typography className={classes.infoLabel}>Cajero</Typography>
              <Typography className={classes.infoValue}>{userName}</Typography>
            </div>
            <Chip label={"ID: " + userId} size="small"
              style={{ backgroundColor: "#e3f2fd", color: "#1565c0", fontWeight: 600 }} />
          </div>

          {/* Fecha y hora */}
          <div className={classes.infoRow}>
            <AccessTimeIcon className={classes.infoIcon} />
            <div style={{ flex: 1 }}>
              <Typography className={classes.infoLabel}>Fecha y hora de apertura</Typography>
              <Typography className={classes.infoValue}>{ahora}</Typography>
            </div>
          </div>

          {/* Monto inicial */}
          <div className={classes.montoSection}>
            <Typography className={classes.sectionTitle}>Efectivo inicial en caja</Typography>
            <TextField
              type="number"
              value={montoInicial}
              onChange={e => {
                const val = e.target.value;
                if (val === "" || parseFloat(val) >= 0) setMontoInicial(val);
              }}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                style: { fontSize: 20, fontWeight: 700 },
                inputProps: { min: 0 }
              }}
              onFocus={e => { if (e.target.value === "0") setMontoInicial(""); }}
            />
            <Typography className={classes.hint}>
              Ingrese el efectivo con el que inicia. Si no tiene fondo de caja, deje en $0.
            </Typography>
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "12px 24px", borderTop: "1px solid #e0e0e0" }}>
          <Button onClick={handleClose} color="danger" size="sm">Cancelar</Button>
          <Button onClick={handleConfirmar} color="success" size="sm" disabled={enviando}>
            Abrir Caja
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalIniciaCaja;
